import styles from "./styles.module.css";
import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import Layout from "./pages/layout";
import { UserDetails } from './types';
import { AppDispatch } from "./store/store";
import { loadUser, createNewSession,setHeaders } from "./store/reducers/app";
import { Provider } from "react-redux";
import {store} from './store/store';
import '@livingdesign/bogle/dist/Bogle.css';
import '@walmart-web/livingdesign-components/index.esm.css';

import { LivingDesignProvider } from "@walmart-web/livingdesign-components";
const DISCLAIMER = "Disclaimer: Please be aware that the responses are generated by GenAI and are based on training guides and may not always be completely accurate, up-to-date, or exhaustive. It is recommended to cross-check information from the given references and open a ticket if you require additional assistance."
export const Disclaimer = () => {
    return (
        <div className={styles.disclaimer}>
            {DISCLAIMER}
        </div>
    );
};


interface EwmmsAppProps {
    userDetails: UserDetails;
    headers: any;
  }
  
  
  export const EwmmsAppComponent = ({ userDetails, headers }: EwmmsAppProps) => {
      const dispatch: AppDispatch = useDispatch();
  
      useEffect(() => {
          dispatch(loadUser(userDetails));
          dispatch(createNewSession()); 
          dispatch(setHeaders(headers));

      }, [headers]);
    
      return (
          <div >
              <Layout />
          </div>
      );
  };
  
  const EwmmsApp = (props: EwmmsAppProps) => {

      const { userDetails, headers } = props;

      


  
      return (
          <React.StrictMode>
              <Provider store={store}>
                  <LivingDesignProvider>
                      <EwmmsAppComponent userDetails={userDetails} headers={headers} />
                  </LivingDesignProvider>
              </Provider>
          </React.StrictMode>
      );
  };
  

  export default EwmmsApp;
